<template>
  <div>
    <!-- <vs-button @click="sortById">To original order</vs-button> -->
    <PlannerHeader id="task-list-header" @click="editTaskDialog({ deadline: today }, true)">tasks</PlannerHeader>

    <FilterOptions v-model="filter" :filterOptions="filterOptions" class="mb-4"/>

<!--     <div class="flex items-center justify-end">
      <vs-input v-if="lotOfTasks" v-model="searchQuery" :clearable="true" placeholder="search" />
      <v-select v-if="lotOfTasks" v-model="sortBy" :clearable="false" :options="sortOptions" style="min-width: 50px"/>
      <ThreeWaySwitch v-if="anyTaskHasSubtask" v-model="forceOpen"/>
      <vs-switch v-if="doneTasksAny" v-model="hideDoneTask" color="dark" icon-pack="feather" vs-icon-on="icon-eye" vs-icon-off="icon-eye-off"  />
     </div> -->
    <div v-if="tasksLoading || !$store.getters.tasksDataLoaded">
      <Loader/>
    </div>
    <div v-else-if="noTasks">
      <EmptyState variant="4" title="Turn chaos into order." subtitle="Focus your energy on the right things. You can't do everything today, but you can do something." subtitle2="What action can you take today that will bring you closer to your goals?">
         <div class="mt-4">
            <vs-button class="w-1/2 m-1" @click.stop="editTaskDialog({ deadline: today }, true)" >
              create task
            </vs-button>
          </div>
      </EmptyState>
    </div>
    <div v-else>
      <!-- filters ===================================================== -->

      <!-- overdue ===================================================== -->
      <div v-if="overdueTasks.length > 0" class="mb-10">
        <TasksDivider title="overdue" :count="overdueTasks.length" :hideAdd="true">
          <div v-if="overdueTasks.length > 2" @click.stop="" class="flex items-center text-danger">
            <feather-icon icon="MoreVerticalIcon" @click="openOverdueContextMenu" :class="actionElementCss" svgClasses="h-5 w-5" />
            <context-menu id="overdue-task-list-context-menu" ref="overdueTaskListCtxMenu">
              <ContextMenuItem class="w-64" title="move all tasks to today" icon="CalendarIcon" @contextMenuClicked="moveOverdueToToday"/>
              <!-- <ContextMenuItem title="delete" icon="Trash2Icon" @contextMenuClicked="$emit('delete', story)" color="text-danger"/> -->
            </context-menu>
          </div>

        </TasksDivider>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="overdueTasks" :group="{ name: 'tasks', put: false }" :banPutting="true" class="mb-4" @dragging="dragHandler" :activeMode="false" @taskDoubleClick="edit" @edit="edit"/>
      </div>

       <TasksDivider title="today" :countDone="todayDoneTasksCount" :count="todayTasks.length" @addCallback="handleAddToday">
          <div v-if="todayTasks.length > 3" @click.stop="" class="flex items-center">
            <feather-icon icon="MoreVerticalIcon" @click="openContextMenu" :class="actionElementCss" svgClasses="h-5 w-5" />
            <context-menu id="task-list-context-menu" ref="taskListCtxMenu">
              <ContextMenuItem title="sort by color" icon="BarChartIcon" @contextMenuClicked="sortTodayByColor"/>
              <ContextMenuItem title="push done tasks" icon="ArrowDownIcon" @contextMenuClicked="pushDoneDown"/>
              <ContextMenuItem title="do the rest tomorrow" icon="CalendarIcon" @contextMenuClicked="moveUndoneToTomorrow"/>
              <ContextMenuItem v-if="todayIsFriday" title="do the rest on monday" icon="CalendarIcon" @contextMenuClicked="restOnMonday"/>
              <!-- <ContextMenuItem title="delete" icon="Trash2Icon" @contextMenuClicked="$emit('delete', story)" color="text-danger"/> -->
            </context-menu>
          </div>
       </TasksDivider>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="todayTasks" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: today }" taskBoxName="today" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>


      <!-- next 7 days ================================================= -->
     <div v-if="filterNext7Days">
        <TasksDivider title="tomorrow" :count="tomorrowTasks.length" @addCallback="handleAddTomorrow"/>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="tomorrowTasks" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: tomorrow }" taskBoxName="tomorrow" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>

        <TasksDivider :title="$store.getters.dayAfterTomorrowWeekDay" :count="dayAfterTomorrowTasks.length" @addCallback="handleAddAfterTomorrow"/>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="dayAfterTomorrowTasks" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: dayAfterTomorrow }" taskBoxName="dayAfterTomorrow" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>

        <TasksDivider :title="weekday(fromToday3)" :count="fromTodayTasks3.length" @addCallback="() => handleAdd(fromToday3)"/>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="fromTodayTasks3" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: fromToday3 }" taskBoxName="fromToday3" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>

        <TasksDivider :title="weekday(fromToday4)" :count="fromTodayTasks4.length" @addCallback="() => handleAdd(fromToday4)"/>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="fromTodayTasks4" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: fromToday4 }" taskBoxName="fromToday4" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>

        <TasksDivider :title="weekday(fromToday5)" :count="fromTodayTasks5.length" @addCallback="() => handleAdd(fromToday5)"/>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="fromTodayTasks5" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: fromToday5 }" taskBoxName="fromToday5" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>

        <TasksDivider :title="weekday(fromToday6)" :count="fromTodayTasks6.length" @addCallback="() => handleAdd(fromToday6)"/>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="fromTodayTasks6" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: fromToday6 }" taskBoxName="fromToday6" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>
      </div>

      <div v-if="filterAll">
        <TasksDivider title="tomorrow" :count="tomorrowTasks.length" @addCallback="handleAddTomorrow"/>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="tomorrowTasks" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: tomorrow }" taskBoxName="tomorrow" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>


        <TasksDivider :title="$store.getters.dayAfterTomorrowWeekDay" :count="dayAfterTomorrowTasks.length" @addCallback="handleAddAfterTomorrow"/>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="dayAfterTomorrowTasks" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: dayAfterTomorrow }" taskBoxName="dayAfterTomorrow" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>

       <TasksDivider title="soon" :count="soonTasks.length" @addCallback="handleAddSoon"/>
        <TasksBox :forceOpen="draggingInProgress ? false : forceOpen" v-model="soonTasks" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: null, showList: 'soon' }" taskBoxName="soon" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>

        <TasksDivider title="someday" :count="somedayTasks.length" @addCallback="handleAddSomeday"/>

        <TasksBox v-if="somedayTasks.length > 0" :forceOpen="draggingInProgress ? false : forceOpen" v-model="somedayTasks" @dragging="dragHandler" :activeMode="draggingInProgress" :moveToChange="{ deadline: null, showList: 'someday' }" taskBoxName="someday" @taskDoubleClick="edit" @edit="edit" class="mb-10"/>
      </div>

      </div>

      <TaskSidebar
        :editedEntity="editedEntity"
        :showDeadline="showDeadline"
        :open="sidebarActive"
        @close="sidebarActive=false"
      />
  </div>
</template>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
import Task from './Task'
import TasksBox from './TasksBox'
import TaskSidebar from './TaskSidebar'
import ThreeWaySwitch from './ThreeWaySwitch'
import TasksDivider from './TasksDivider'
import { midnight, midnightTomorrow, addDays, isFriday, getNextMonday } from '@/helpers/date'
import vSelect from 'vue-select'
import PlannerHeader from '../Planner/PlannerHeader'
import FilterOptions from '../Generic/FilterOptions'
import Loader from '../Generic/Loader'


export default {
  components: {
    draggable,
    Task,
    TasksBox,
    ThreeWaySwitch,
    TasksDivider,
    vSelect,
    PlannerHeader,
    FilterOptions,
    Loader,
    TaskSidebar,
  },
  data () {
    return {
      filter: this.$store.getters.tasksListFilter || 'all',
      filterOptions: ['today', 'next 7 days', 'all'],
      forceOpen: null,
      showDeadline: true,
      editedEntity: {},
      searchQuery: null,
      draggingInProgress: false,
      hideDoneTask: true,
      tasksLoading: true,
      sidebarActive: false,
      // doneTasks: [],
      overdueTasks: [],
      todayTasks: [],
      tomorrowTasks: [],
      dayAfterTomorrowTasks: [],
      fromTodayTasks3: [],
      fromTodayTasks4: [],
      fromTodayTasks5: [],
      fromTodayTasks6: [],
      somedayTasks: [],
      soonTasks: [],
      sortBy: '',
      sortOptions: [
        '',
        'Created Date',
        'Color',
        'Title',
        'Done'
      ],
    }
  },
  watch: {
    '$store.getters.plannerTasks': {
      immediate: false,
      handler () {
        console.log('$store.getters.plannerTasks watcher')
        this.renderTasks()
        // setTimeout(() => this.renderTasks(), 200)
      }
    },
    'hideDoneTask': {
      immediate: false,
      handler () {
        console.log('hideDoneTask watcher')
        this.renderTasks()
      }
    },
    'filter': {
      immediate: false,
      handler (filter) {
        if (filter) {
          this.$store.commit('SET_TASKS_LIST_FILTER', { filter: this.filter })
        }

        this.renderTasks()

        if (this.filterNext7Days) {
          this.notifier.openNext7DaysTab(this.$store)
        }

        if (this.filterToday) {
          this.notifier.openTodayTab(this.$store)
        }
      }
    },
    '$store.getters.filter': {
      immediate: false,
      handler (filter) {
        this.renderTasks()
      }
    },
    'searchQuery': {
      immediate: false,
      handler () {
        console.log('sortBy watcher')
        this.renderTasks()
      }
    },
    // '$store.getters.tasksDataLoaded': {
    //   immediate: false,
    //   handler (loaded) {
    //     console.log('Tasks $store.getters.tasksDataLoaded', loaded)
    //     if (loaded) {
    //       this.renderTasks()
    //     }
    //   }
    // },
  },
  mounted () {
    if (this.$store.getters.tasksDataLoaded) {
      setTimeout(() => { this.renderTasks() }, 200)
    }
  },
  methods: {
    openContextMenu () {
      this.$root.$emit('closeAllContextMenus')

      if (this.$refs.taskListCtxMenu) {
        this.$refs.taskListCtxMenu.open()
      }
    },
    openOverdueContextMenu () {
      this.$root.$emit('closeAllContextMenus')

      if (this.$refs.overdueTaskListCtxMenu) {
        this.$refs.overdueTaskListCtxMenu.open()
      }
    },
    moveOverdueToToday () {
      const updates = _.map(_.sortBy(this.overdueTasks, ['backgroundColor', 'listIndex']), (task) => {
        return { task, updateFields: { deadline: this.today } }
      })

      this.$store.dispatch('UPDATE_TASKS_BATCH', { updates })
    },
    moveUndoneToTomorrow () {
      const updates = _.map(_.reject(_.sortBy(this.todayTasks, ['backgroundColor', 'listIndex']), 'done'), (task) => {
        return { task, updateFields: { deadline: this.tomorrow } }
      })

      this.$store.dispatch('UPDATE_TASKS_BATCH', { updates })
    },
    restOnMonday () {
      const updates = _.map(_.reject(_.sortBy(this.todayTasks, ['backgroundColor', 'listIndex']), 'done'), (task) => {
        return { task, updateFields: { deadline: getNextMonday() } }
      })

      this.$store.dispatch('UPDATE_TASKS_BATCH', { updates })
    },
    sortTodayByColor () {
      console.log(this.todayTasks)

      const updates = _.map(_.sortBy(this.todayTasks, ['backgroundColor', 'listIndex']), (task, index) => {
        return { task, updateFields: { listIndex: index + 1 } }
      })

      this.$store.dispatch('UPDATE_TASKS_BATCH', { updates })
    },
    pushDoneDown () {
      const doneTasks = _.filter(this.todayTasks, 'done')
      const todoTasks = _.filter(this.todayTasks, (task) => !task.done)

      const updates = _.map(_.concat(doneTasks, todoTasks), (task, index) => {
        console.log(task.title, task.backgroundColor)
        return { task, updateFields: { listIndex: index + 1 } }
      })

      this.$store.dispatch('UPDATE_TASKS_BATCH', { updates })
    },
    renderTasks () {
      console.log('render tasks')
      this.overdueTasks = this.filerAndSortTasks(this.keepOrderBy(
        this.overdueTasks,
        this.$store.getters.overdueTasks,
      ))

      this.todayTasks = this.filerAndSortTasks(this.keepOrderBy(
        this.todayTasks,
        this.$store.getters.todayTasks,
      ))

      this.tomorrowTasks = this.filerAndSortTasks(this.keepOrderBy(
        this.tomorrowTasks,
        this.$store.getters.tomorrowTasks,
      ))

      this.dayAfterTomorrowTasks = this.filerAndSortTasks(this.keepOrderBy(
        this.dayAfterTomorrowTasks,
        this.$store.getters.dayAfterTomorrowTasks,
      ))

      this.fromTodayTasks3 = this.filerAndSortTasks(this.keepOrderBy(
        this.fromTodayTasks3,
        this.$store.getters.fromTodayTasks3,
      ))

      // concole.log('fromTodayTasks4', this.$store.getters.fromTodayTasks4)

      this.fromTodayTasks4 = this.filerAndSortTasks(this.keepOrderBy(
        this.fromTodayTasks4,
        this.$store.getters.fromTodayTasks4,
      ))

      this.fromTodayTasks5 = this.filerAndSortTasks(this.keepOrderBy(
        this.fromTodayTasks5,
        this.$store.getters.fromTodayTasks5,
      ))

      this.fromTodayTasks6 = this.filerAndSortTasks(this.keepOrderBy(
        this.fromTodayTasks6,
        this.$store.getters.fromTodayTasks6,
      ))

      // this.dayAfterTomorrowTasks5 = this.filerAndSortTasks(this.keepOrderBy(
      //   this.dayAfterTomorrowTasks5,
      //   this.$store.getters.dayAfterTomorrowTasks5,
      // ))

      this.soonTasks = this.filerAndSortTasks(this.keepOrderBy(
        this.soonTasks,
        this.$store.getters.soonTasks,
      ))

      this.somedayTasks = this.filerAndSortTasks(this.keepOrderBy(
        this.somedayTasks,
        this.$store.getters.somedayTasks,
      ))

      this.tasksLoading = false
    },
    // loadTasks () {
    //   console.log('loading tasks')
    //   this.tasksLoading = true

    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       this.renderTasks()
    //     }, 1000)
    //   })
    // },
    weekday (day) {
      return this.$options.filters.weekDay(day)
    },
    handleAddToday () {
      console.log('handleAddToday')
      this.editTaskDialog({ deadline: this.today }, true)
    },
    handleAddTomorrow () {
      this.editTaskDialog({ deadline: this.tomorrow }, true)
    },
    handleAddAfterTomorrow () {
      this.editTaskDialog({ deadline: this.dayAfterTomorrow }, true)
    },
    handleAdd (deadline) {
      this.editTaskDialog({ deadline }, true)
    },
    handleAddSoon () {
      this.editTaskDialog({ showList: 'soon' }, true)
    },
    handleAddSomeday () {
      this.editTaskDialog({ showList: 'someday' }, true)
    },
    edit (task) {
      this.editTaskDialog(task, true, true)
    },
    editTaskDialog (task, showDeadline = true) {
      console.log('editTaskDialog', this.sidebarActive)
      this.showDeadline = showDeadline
      this.editedEntity = task
      this.sidebarActive = true
    },
    closeTaskDialog () {
      this.editedEntity = {}
      this.sidebarActive = false
    },
    keepOrderBy (originalArray, newArray) {
      return _.sortBy(
        newArray, (goal) => _.findIndex(originalArray, (g) => g.id === goal.id)
      )
    },
    sortById () {
      this.tasks = this.tasks.sort((a, b) => a.id - b.id)
    },
    dragHandler (dragging) {
      this.draggingInProgress = dragging
    },
    filerAndSortTasks (tasks) {
      let firstLevelSortedTasks = _.sortBy(tasks, (task) => task.createdAt.seconds).reverse()

      if (_.get(this.$store.getters.filter, 'color')) {
        firstLevelSortedTasks = _.filter(firstLevelSortedTasks, (task) => task.backgroundColor ===this.$store.getters.filter.color)
      }


      return _.sortBy(firstLevelSortedTasks, (task) => _.isNumber(task.listIndex) ? task.listIndex : task.createdAt.seconds).reverse()
      // const filteredTasks = _.filter(tasks, (task) => {
      //   if (this.searchQuery) {
      //     return _.includes(_.lowerCase(task.title), _.lowerCase(this.searchQuery))
      //   } else {
      //     return !task.done || (this.hideDoneTask && task.done)
      //   }
      // })

      // const filteredTasks = _.filter(tasks, (task) => {
      //   if (this.filter) {
      //     return _.includes(_.lowerCase(task.title), _.lowerCase(this.searchQuery))
      //   } else {
      //     return !task.done || (this.hideDoneTask && task.done)
      //   }
      // })

      // if (this.filter) {
      //   return _.filter(tasks, (task) => {
      //     return (_.includes(this.filter, 'planned') && task.deadline) ||
      //       (_.includes(this.filter, 'backlog') && !task.deadline)
      //   })
      // } else {
      // return this.tasks
      // }


      // if (!this.sortBy) return filteredTasks

      // return _.sortBy(filteredTasks,
      //   (task) => {
      //     if (this.sortBy === 'Created Date') {
      //       return task.createdAt.toDate()
      //     } else if (this.sortBy === 'Done') {
      //       return task.done
      //     } else if (this.sortBy === 'Title') {
      //       return task.title
      //     } else {
      //       return task.backgroundColor
      //     }
      //   })
    }
  },
  computed: {
    todayIsFriday () {
      return isFriday()
    },
    noTasks () {
      return (this.overdueTasks.length + this.todayTasks.length +
      this.tomorrowTasks.length + this.dayAfterTomorrowTasks.length + this.soonTasks.length +
      this.somedayTasks.length) === 0
    },
    todayDoneTasksCount () {
      return _.size(_.filter(this.todayTasks, 'done'))
    },
    filterAll () {
      return _.includes(this.filter, 'all')
    },
    filterToday () {
      return _.includes(this.filter, 'today')
    },
    filterNext7Days () {
      return _.includes(this.filter, 'next 7 days')
    },
    showDividers () {
      return _.includes(this.filter, 'planned')
    },
    anySomedayTasks () {
      return this.somedayTasks.length > 0
    },
    anyTaskHasSubtask () {
      return _.some(this.$store.getters.plannerTasks, (task) => task.subtasks && task.subtasks.length > 0)
    },
    doneTasksAny () {
      return _.some(this.$store.getters.plannerTasks, (task) => task.done)
    },
    lotOfTasks () {
      return this.$store.getters.plannerTasks.length > 20
    },
    today () {
      return midnight()
    },
    tomorrow () {
      return midnightTomorrow()
    },
    dayAfterTomorrow () {
      return addDays(this.tomorrow, 1)
    },
    fromToday3 () {
      return addDays(this.today, 3)
    },
    fromToday4 () {
      return addDays(this.today, 4)
    },
    fromToday5 () {
      return addDays(this.today, 5)
    },
    fromToday6 () {
      return addDays(this.today, 6)
    },
  },
  created () {
    this.$root.$on('closeAllContextMenus', () => {
      if (this.$refs.taskListCtxMenu) {
        this.$refs.taskListCtxMenu.ctxVisible = false
      }

      if (this.$refs.overdueTaskListCtxMenu) {
        this.$refs.overdueTaskListCtxMenu.ctxVisible = false
      }
    })
  },
}

</script>

<style lang="scss">
.skeleton-input {
  .vs-inputx {
    border: none !important;
    background: transparent !important;
  }

}
.task-handle {
  cursor: move;
}
.task-drag {
  cursor: move !important;
}
.ghost-task {
  opacity: 0.01;
}

.flip-list-move {
  transition: transform 0.5s;
}

.tasks-box {
  border-style: dashed;
  border-width: 2px;
  border-radius: 8px;
  border-color: rgba(112, 112, 112, 0.4);
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  min-height: 0.5rem
}

.tasks-box__active {
  border-color: rgba(112, 20, 112, 0.8);
  min-height: 5rem
}

#task-list-context-menu {
  li {
    min-width: 200px
  }
}

</style>
